import type { DsBadge } from '../types';

/** Map a raw topic string to a coarse badge for colour-coding rows + markers.
 *  Order matters: most specific match first. */
export function classifyTopic(topic: string): DsBadge {
  const t = topic.toLowerCase();
  if (
    t.includes('surveillance_traffic/') ||
    t.includes('tisb') ||
    t.includes('surveillance_sensors') ||
    t.includes('/live_')
  ) {
    return 'surveillance';
  }
  if (t.includes('traffic_control')) return 'traffic';
  // Checked before the generic '/aircraft/' telemetry match below, which
  // would otherwise mis-badge `v1/output/aircraft/{sn}/events` as telemetry.
  if (t.includes('/events') || t.includes('/alerts')) return 'system';
  // `v1/output/aircraft/{sn}/waypoint_pred` is a mission message, not airframe
  // telemetry — the generic `/aircraft/` rule below would badge it as such.
  if (t.includes('/waypoint_')) return 'system';
  if (t.includes('telemetry') || t.includes('/drones/') || t.includes('/aircraft/')) {
    return 'telemetry';
  }
  return 'system';
}
